import { Post } from '@tribeplatform/gql-client/types'

import type { StaticField, View } from '../../Views/types'
import { PostsCard } from './PostsCard'
import { PostsCarousel } from './PostsCarousel'
import { PostsGallery } from './PostsGallery'
import { PostsList } from './PostsList'

interface Props {
  style: View['style']
  posts: Post[]
  fields: StaticField[]
  gallerySize?: View['gallerySize']
  showDivider?: View['showDivider']
  activeFieldId?: string
  showMoreButton: JSX.Element
  linkTo?: string
  preview: boolean
}
export const GenericPostsList = ({
  style,
  posts,
  fields,
  gallerySize,
  showDivider,
  activeFieldId,
  showMoreButton,
  linkTo,
  preview,
}: Props) => {
  switch (style) {
    case 'gallery':
      return (
        <PostsGallery
          posts={posts}
          fields={fields}
          gallerySize={gallerySize}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
          linkTo={linkTo}
          preview={preview}
        />
      )
    case 'list':
      return (
        <PostsList
          posts={posts}
          fields={fields}
          showDivider={showDivider}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
          linkTo={linkTo}
          preview={preview}
        />
      )
    case 'card':
      return (
        <PostsCard
          posts={posts}
          fields={fields}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
          preview={preview}
        />
      )
    case 'carousel':
      return (
        <PostsCarousel
          posts={posts}
          fields={fields}
          gallerySize={gallerySize}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
          linkTo={linkTo}
          preview={preview}
        />
      )
    default:
      return null
  }
}
